import styled from 'styled-components';

export const IntersectionBox = styled('span')`
  height: 1px;
  display: block;
`;
